import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_BASE_URL, apiFetch } from '../config/api';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Check auth status on mount. The backend reads the HttpOnly cookie
  // itself (sent automatically via credentials: 'include'), so there's no
  // token for the frontend to read, store, or pass along.
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await apiFetch(`${API_BASE_URL}/auth/user`);
      
      if (response.ok) {
        const data = await response.json();
        setUser(data.authenticated ? data : null);
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = () => {
    window.location.href = `${API_BASE_URL}/auth/login`;
  };

  const logout = async () => {
    try {
      // Backend clears the HttpOnly cookie server-side
      await apiFetch(`${API_BASE_URL}/auth/logout`);
    } catch (error) {
      console.error('Logout request failed:', error);
    }
    setUser(null);
    navigate('/');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}